import React from "react";
import {
    Box,
    Card,
    CardHeader,
    CardBody,
    Center,
    FormControl,
    FormLabel,
    Heading,
    Image,
    Input,
    Text,
    VStack,
} from "@chakra-ui/react";
import { getColor, getComponent } from "../../../brandConfig";

interface ProfilePhotoUploaderProps {
    profilePhoto: string;
    fName: string;
    lName: string;
    onPhotoUpload: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const ProfilePhotoUploader: React.FC<ProfilePhotoUploaderProps> = ({
    profilePhoto,
    fName,
    lName,
    onPhotoUpload,
}) => {
    const cardGradientBg = getColor("background.cardGradient");
    const cardBorder = getColor("border.darkCard");
    const textSecondary = getColor("text.secondaryDark");
    const textMuted = getColor("text.mutedDark");
    const textInverse = getColor("text.inverse");
    const accentBlue = getColor("accentBlue");

    return (
        <Card
            bg={cardGradientBg}
            backdropFilter="blur(10px)"
            boxShadow="0 8px 32px 0 rgba(0, 0, 0, 0.37)"
            borderWidth="1px"
            borderColor={cardBorder}
            overflow="hidden"
        >
            <CardHeader borderBottomWidth="1px" borderColor={cardBorder}>
                <Heading size="md" color={textInverse}>
                    Profile Photo
                </Heading>
            </CardHeader>
            <CardBody>
                <VStack spacing={6} align="center">
                    <Box
                        position="relative"
                        width="200px"
                        height="200px"
                        borderRadius="full"
                        overflow="hidden"
                        border="3px solid"
                        borderColor={accentBlue}
                    >
                        {profilePhoto ? (
                            <Image
                                src={profilePhoto}
                                alt={`${fName} ${lName}`}
                                width="100%"
                                height="100%"
                                objectFit="cover"
                            />
                        ) : (
                            <Center width="100%" height="100%" bg="rgba(59, 130, 246, 0.1)">
                                <Text fontSize="6xl" color={textInverse}>
                                    {fName?.[0]?.toUpperCase() || ""}
                                    {lName?.[0]?.toUpperCase() || ""}
                                </Text>
                            </Center>
                        )}
                    </Box>

                    <FormControl>
                        <FormLabel color={textSecondary} fontWeight="500" fontSize="sm" mb={2}>
                            Upload New Photo
                        </FormLabel>
                        <Input
                            type="file"
                            accept="image/*"
                            onChange={onPhotoUpload}
                            bg={getComponent("form", "fieldBg")}
                            border="1px"
                            borderColor={getComponent("form", "fieldBorder")}
                            borderRadius="lg"
                            _focus={{
                                borderColor: getComponent("form", "fieldBorderFocus"),
                                boxShadow: getComponent("form", "fieldShadowFocus"),
                            }}
                        />
                        <Text fontSize="sm" color={textMuted} mt={1}>
                            Upload a square photo for best results
                        </Text>
                    </FormControl>
                </VStack>
            </CardBody>
        </Card>
    );
};
